import React, {useEffect, useState} from "react";
import {Redirect, withRouter} from "react-router";
import {Link, Typography, withStyles} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import {LoadingCircular} from "../loading/loaders";
import * as links from "../../constants/links";
import {Alert} from "@material-ui/lab";
import {useSelector} from "react-redux";
import {confirmRegistration} from "../../sagas/auth/actions";


const styles = {

}

function ConfirmRegistration(props){
    const {t,classes,match} = props;
    const [loading,setLoading] = useState(true);
    const {authenticated} = useSelector((state)=>state.authState);
    useEffect(()=>{
        confirmRegistration({
            token :match.params.token
        });
    },[]);
    if (authenticated){
        return <Redirect to={{pathname:links.HOME}}/>
    }
    return loading?<LoadingCircular/>:<Alert severity={"success"} className={classes.alert}>
        <Typography variant="h1" style={{fontWeight: 700, marginBottom: '1rem', fontSize: '8rem'}}>{t("text.account_enabled_message")}</Typography>
        <Typography variant="caption" style={{fontSize: '1rem'}}>
            <Link className={classes.link} href={"#"} onClick={(e) => {
                e.preventDefault();
                window.location.replace(links.HOME);
            }}>{t("label.go_to_home")}</Link>
        </Typography>
    </Alert>
}

export default withRouter(withStyles(styles)(withTranslation()(ConfirmRegistration)));